import { CustomComponentProps } from "utils/types/general.types";
import MyModal from "./MyModal";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";

export type ConfirmDeleteModalProps = CustomComponentProps & {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    text: string;
    handleDelete: Function;
};

const ConfirmDeleteModal = ({
    open,
    setOpen,
    text,
    handleDelete,
    className,
    style = {}
}: ConfirmDeleteModalProps) => {
    const onClickDelete = () => {
        handleDelete();
        setOpen(false);
    };

    return (
        <MyModal
            open={open}
            setOpen={setOpen}
            className={`delete-modal ${className}`}
            style={style}
        >
            <div className="flex flex-col w-full justify-center items-center gap-3">
                <div className="delete-info-icon">
                    <InfoRoundedIcon className="text-momeento-50" />
                </div>
                <h1 className="dark:text-white">{text}</h1>
                <p className="dark:text-white">
                    Are you sure you want to delete
                </p>
                <div className="flex justify-center items-center gap-5">
                    <button
                        className="bg-slate-400 text-white text-center rounded-full w-fit px-3 py-1"
                        onClick={() => setOpen(false)}
                    >
                        No
                    </button>
                    <button
                        className="bg-momeento-50 text-white text-center rounded-full w-fit px-3 py-1"
                        onClick={onClickDelete}
                    >
                        yes
                    </button>
                </div>
            </div>
        </MyModal>
    );
};

export default ConfirmDeleteModal;
